<div class="min-h-screen bg-gray-50 p-6">
  <!-- Header -->
  <div class="mb-6">
    <div class="flex items-center gap-3 mb-2">
      <a routerLink="/dashboard/config" class="p-2 hover:bg-gray-200 rounded-lg transition-colors">
        <svg class="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
        </svg>
      </a>
      <div class="p-2 bg-blue-500 rounded-lg">
        <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
      </div>
      <div>
        <h1 class="text-2xl font-bold text-gray-800">Reportes Cargados</h1>
        <p class="text-gray-500 text-sm">Historial de reportes Wompi y Plink cargados al sistema</p>
      </div>
    </div>
  </div>

  <!-- Stats Cards -->
  <div class="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6" *ngIf="response">
    <div class="bg-white rounded-lg border border-gray-200 p-4">
      <div class="flex items-center gap-3">
        <div class="p-2 bg-green-100 rounded-lg">
          <svg class="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <div>
          <p class="text-sm text-gray-500">Wompi Total</p>
          <p class="text-xl font-bold text-gray-800">{{ response.totalWompiReports }}</p>
        </div>
      </div>
    </div>
    <div class="bg-white rounded-lg border border-gray-200 p-4">
      <div class="flex items-center gap-3">
        <div class="p-2 bg-blue-100 rounded-lg">
          <svg class="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <div>
          <p class="text-sm text-gray-500">Plink Total</p>
          <p class="text-xl font-bold text-gray-800">{{ response.totalPlinkReports }}</p>
        </div>
      </div>
    </div>
    <div class="bg-white rounded-lg border border-gray-200 p-4">
      <div class="flex items-center gap-3">
        <div class="p-2 bg-emerald-100 rounded-lg">
          <svg class="w-5 h-5 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <div>
          <p class="text-sm text-gray-500">Conciliados</p>
          <p class="text-xl font-bold text-emerald-600">{{ response.totalConciliatedWompi +
            response.totalConciliatedPlink }}</p>
        </div>
      </div>
    </div>
    <div class="bg-white rounded-lg border border-gray-200 p-4">
      <div class="flex items-center gap-3">
        <div class="p-2 bg-amber-100 rounded-lg">
          <svg class="w-5 h-5 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <div>
          <p class="text-sm text-gray-500">Pendientes</p>
          <p class="text-xl font-bold text-amber-600">{{ response.totalPendingWompi + response.totalPendingPlink }}</p>
        </div>
      </div>
    </div>
  </div>

  <!-- Filters -->
  <div class="bg-white rounded-lg border border-gray-200 p-4 mb-6">
    <div class="flex flex-wrap items-end gap-4">
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Desde</label>
        <input type="date" [(ngModel)]="dateFrom"
          class="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Hasta</label>
        <input type="date" [(ngModel)]="dateTo"
          class="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Estado</label>
        <select [(ngModel)]="conciliatedFilter"
          class="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
          <option value="all">Todos</option>
          <option value="true">Conciliados</option>
          <option value="false">Pendientes</option>
        </select>
      </div>
      <div *ngIf="activeTab === 'wompi'">
        <label class="block text-sm font-medium text-gray-700 mb-1">En Sistema</label>
        <select [(ngModel)]="linkedFilter"
          class="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
          <option value="all">Todos</option>
          <option value="true">Sí (Con Link/Recibo)</option>
          <option value="false">No (Sin Link)</option>
        </select>
      </div>
      <button (click)="applyFilters()"
        class="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
        Filtrar
      </button>
      <button (click)="clearFilters()"
        class="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors">
        Limpiar
      </button>
    </div>
  </div>

  <!-- Tabs -->
  <div class="bg-white rounded-lg border border-gray-200 overflow-hidden">
    <div class="flex border-b border-gray-200">
      <button (click)="setTab('wompi')"
        [class]="activeTab === 'wompi' ? 'border-b-2 border-green-500 text-green-600 bg-green-50' : 'text-gray-500 hover:bg-gray-50'"
        class="flex-1 px-6 py-3 text-sm font-medium transition-colors">
        <div class="flex items-center justify-center gap-2">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
          </svg>
          Reportes Wompi
          <span class="px-2 py-0.5 text-xs rounded-full"
            [class]="activeTab === 'wompi' ? 'bg-green-200 text-green-800' : 'bg-gray-200 text-gray-600'">
            {{ wompiReports.length }}
          </span>
        </div>
      </button>
      <button (click)="setTab('plink')"
        [class]="activeTab === 'plink' ? 'border-b-2 border-blue-500 text-blue-600 bg-blue-50' : 'text-gray-500 hover:bg-gray-50'"
        class="flex-1 px-6 py-3 text-sm font-medium transition-colors">
        <div class="flex items-center justify-center gap-2">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          Reportes Plink
          <span class="px-2 py-0.5 text-xs rounded-full"
            [class]="activeTab === 'plink' ? 'bg-blue-200 text-blue-800' : 'bg-gray-200 text-gray-600'">
            {{ plinkReports.length }}
          </span>
        </div>
      </button>
    </div>

    <!-- Wompi Reports Table -->
    <div *ngIf="activeTab === 'wompi'" class="overflow-x-auto">
      <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-gray-50">
          <tr>
            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Transacción</th>
            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Fecha</th>
            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Pagador</th>
            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Monto</th>
            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">ID Conciliación
            </th>
            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Estado</th>
            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">En Sistema</th>
            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Cargado</th>
            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Conciliado</th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          <tr *ngFor="let report of wompiReports" class="hover:bg-gray-50">
            <td class="px-4 py-3 whitespace-nowrap">
              <div class="text-sm font-medium text-gray-900">{{ report.transactionId }}</div>
              <div class="text-xs text-gray-500">{{ report.reference }}</div>
            </td>
            <td class="px-4 py-3 whitespace-nowrap text-sm text-gray-600">
              {{ formatDate(report.transactionDate) }}
            </td>
            <td class="px-4 py-3 whitespace-nowrap">
              <div class="text-sm text-gray-900">{{ report.payerName }}</div>
              <div class="text-xs text-gray-500">{{ report.payerEmail }}</div>
            </td>
            <td class="px-4 py-3 whitespace-nowrap">
              <div class="text-sm font-medium text-gray-900">{{ formatCurrency(report.amount) }}</div>
              <div class="text-xs text-gray-500">{{ report.paymentMethod }}</div>
            </td>
            <td class="px-4 py-3 whitespace-nowrap text-sm text-gray-600">
              {{ report.reconciliationId || '-' }}
              <span *ngIf="report.isAutoConciliable"
                class="ml-1 inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-purple-100 text-purple-800"
                title="Conciliable Automáticamente">
                <svg class="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
                Auto
              </span>
            </td>
            <td class="px-4 py-3 whitespace-nowrap">
              <span *ngIf="report.conciliated"
                class="px-2 py-1 text-xs font-medium rounded-full bg-green-100 text-green-800">
                Conciliado
              </span>
              <span *ngIf="!report.conciliated"
                class="px-2 py-1 text-xs font-medium rounded-full bg-amber-100 text-amber-800">
                Pendiente
              </span>
            </td>
            <td class="px-4 py-3 whitespace-nowrap">
              <div class="flex flex-col gap-1">
                <span class="px-2 py-1 text-xs font-medium rounded-full w-fit" [ngClass]="{
                            'bg-green-100 text-green-800': report.systemStatus === 'Completo (Link + Recibo)',
                            'bg-orange-100 text-orange-800': report.systemStatus && report.systemStatus.includes('Solo'),
                            'bg-gray-100 text-gray-800': !report.systemStatus || report.systemStatus === 'No Encontrado'
                          }">
                  {{ report.systemStatus || 'No verificado' }}
                </span>
                <div class="flex gap-2 mt-1">
                  <a *ngIf="report.enrollmentId" [routerLink]="['/dashboard/enrollments/view', report.enrollmentId]"
                    target="_blank" class="text-blue-600 hover:text-blue-800 text-xs flex items-center gap-1"
                    title="Ver Inscripción">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                    </svg>
                    Inscripción
                  </a>
                  <a *ngIf="report.incomeReceiptId"
                    [routerLink]="['/dashboard/incomes/receipts/view', report.incomeReceiptId]" target="_blank"
                    class="text-green-600 hover:text-green-800 text-xs flex items-center gap-1" title="Ver Recibo">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                    Recibo
                  </a>
                </div>
              </div>
            </td>
            <td class="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
              {{ formatDate(report.createdAt) }}
            </td>
            <td class="px-4 py-3 whitespace-nowrap text-sm" [class.text-green-600]="report.conciliatedAt"
              [class.text-gray-400]="!report.conciliatedAt">
              {{ report.conciliatedAt ? formatDate(report.conciliatedAt) : '-' }}
            </td>
          </tr>
          <tr *ngIf="wompiReports.length === 0">
            <td colspan="9" class="px-4 py-8 text-center text-gray-500">
              No se encontraron reportes Wompi con los filtros aplicados
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Plink Reports Table -->
    <div *ngIf="activeTab === 'plink'" class="overflow-x-auto">
      <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-gray-50">
          <tr>
            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Código Auth</th>
            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Fecha Tx</th>
            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Franquicia</th>
            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Total</th>
            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Comisión</th>
            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Neto</th>
            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Estado</th>
            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Cargado</th>
            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Conciliado</th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          <tr *ngFor="let report of plinkReports" class="hover:bg-gray-50">
            <td class="px-4 py-3 whitespace-nowrap">
              <div class="text-sm font-medium text-gray-900">{{ report.authorizationCode }}</div>
              <div class="text-xs text-gray-500">{{ report.cardType }}</div>
            </td>
            <td class="px-4 py-3 whitespace-nowrap text-sm text-gray-600">
              {{ formatDate(report.transactionDate) }}
            </td>
            <td class="px-4 py-3 whitespace-nowrap text-sm text-gray-600">
              {{ report.franchise }}
            </td>
            <td class="px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900">
              {{ formatCurrency(report.totalValue) }}
            </td>
            <td class="px-4 py-3 whitespace-nowrap text-sm text-red-600">
              {{ formatCurrency(report.commissionValue) }}
            </td>
            <td class="px-4 py-3 whitespace-nowrap text-sm font-medium text-green-600">
              {{ formatCurrency(report.netValue) }}
            </td>
            <td class="px-4 py-3 whitespace-nowrap">
              <span *ngIf="report.conciliated"
                class="px-2 py-1 text-xs font-medium rounded-full bg-green-100 text-green-800">
                Conciliado
              </span>
              <span *ngIf="!report.conciliated"
                class="px-2 py-1 text-xs font-medium rounded-full bg-amber-100 text-amber-800">
                Pendiente
              </span>
            </td>
            <td class="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
              {{ formatDate(report.createdAt) }}
            </td>
            <td class="px-4 py-3 whitespace-nowrap text-sm" [class.text-green-600]="report.conciliatedAt"
              [class.text-gray-400]="!report.conciliatedAt">
              {{ report.conciliatedAt ? formatDate(report.conciliatedAt) : '-' }}
            </td>
          </tr>
          <tr *ngIf="plinkReports.length === 0">
            <td colspan="9" class="px-4 py-8 text-center text-gray-500">
              No se encontraron reportes Plink con los filtros aplicados
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <!-- Pagination -->
    <div class="mt-4 bg-white rounded-lg border border-gray-200" *ngIf="currentTotalRecords > 0">
      <p-paginator [rows]="pageSize" [totalRecords]="currentTotalRecords" [rowsPerPageOptions]="[10, 25, 50, 100]"
        (onPageChange)="onPageChange($event)" [showCurrentPageReport]="true"
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
        [first]="(currentPage - 1) * pageSize">
      </p-paginator>
    </div>
  </div>
</div>